import React, { Fragment } from "react";
import PropTypes from "prop-types";

import { createPortal } from "react-dom";
import { Overlay } from "components";
import cuid from "cuid";
import i24 from "assets/images/i24.svg";

const propTypes = {
  children: PropTypes.any.isRequired,
  orientation: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  style: PropTypes.object.isRequired,
};

const defaultProps = {
  orientation: "right",
  className: "more-options",
  style: {},
};

type State = {
  top: ?number,
  right: ?number,
  left: ?number,
};

class TripleDotBtn extends React.Component<any, State> {
  constructor() {
    super();
    this.id = cuid();
    this.node = null;
    this.hook = document.getElementById("overlay");
    this.html = document.documentElement;
    this.actions.open = this.actions.open.bind(this);
    this.actions.close = this.actions.close.bind(this);
  }

  componentDidMount() {
    this.node = document.getElementById(this.id);
  }

  state = { top: null, right: null, left: null };

  actions = {
    open(e): void {
      e.stopPropagation();
      const rect = this.node.getBoundingClientRect();
      this.setState({
        top: rect.top + this.html.scrollTop,
        right: this.html.clientWidth - rect.right,
        left: rect.left,
      });
    },
    close(e): void {
      e.stopPropagation();
      this.setState({ top: null, right: null, left: null });
    },
  };

  renderChildren = () => {
    const { children } = this.props;
    if (typeof children === "function") return children({ close: this.actions.close });
    return React.Children.map(children, child => (
      <div onClick={e => this.actions.close(e)}>{child}</div>
    ));
  };

  render() {
    const { orientation, className, button, style } = this.props;
    const { top, right, left } = this.state;
    const visibilityStyle = top ? { visibility: "visible", ...style } : style;

    let styles = {};
    if (top) {
      styles = { display: "block", top: top + 30, zIndex: 3, position: "absolute" };
    }
    if (orientation === "left") {
      styles.left = left;
    } else {
      styles.right = right;
    }

    return (
      <Fragment>
        <div
          className={className}
          id={this.id}
          onClick={e => this.actions.open(e)}
          style={visibilityStyle}
        >
          {button || <img src={i24} alt="opcje" />}
        </div>
        {top !== null &&
          createPortal(
            <Overlay close={this.actions.close}>
              <div className="options-list" style={styles}>
                {this.renderChildren()}
              </div>
            </Overlay>,
            this.hook
          )}
      </Fragment>
    );
  }
}

TripleDotBtn.propTypes = propTypes;
TripleDotBtn.defaultProps = defaultProps;
export default TripleDotBtn;



// WEBPACK FOOTER //
// ./src/components/ui/TripleDotBtn.jsx